import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import * as authActions from 'redux/modules/auth';
import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({ user: state.auth.user, loginError: state.auth.loginError }),
  authActions)
export default class AdminLogin extends Component {

  handleSubmit = (event) => {
    event.preventDefault();
    const input = this.refs.username;
    const pwd = this.refs.password;
    this.props.login(input.value, pwd.value, true);
    input.value = '';
  }

  render() {
    const { user, logout, loginError } = this.props;
    const styles = require('./AdminLogin.scss');
    const { t } = this.props;

    return (
      <div className={styles.loginPage + ' container'}>
        <Helmet title="Login" />
        <h1>{t('login.title_admin')}</h1>
        {!user &&
          <div>
            <form className="login-form form-inline" onSubmit={this.handleSubmit}>
              <div className="form-group">
                <input type="text" ref="username" placeholder={t('login.username')} className="form-control" />
                <input type="password" ref="password" placeholder={t('login.password')} className="form-control" />
              </div>

              <button className="btn btn-success" onClick={this.handleSubmit}><i className="fa fa-sign-in" />{' '}Log In</button>
            </form>
            <p><Link to="/forgot-password">{t('passwordRecovery.forgot_title')}</Link></p>

            {loginError &&
              <div className="alert alert-danger" role="alert">
                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                {' '}
                {loginError}
              </div>}

          </div>
        }
        {user &&
          <div>
            <p>You are currently logged in as {user.name}.</p>

            <div>
              <button className="btn btn-danger" onClick={logout}><i className="fa fa-sign-out" />{' '}Log Out</button>
            </div>
          </div>
        }
      </div>
    );
  }
}
